import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

export const useReadingTemplatesByService = (serviceUid) => {
    return useQuery({
        queryKey: ['reading-templates', { serviceUid }],
        queryFn: async () => {
            return await api.getReadingTemplatesByService(serviceUid);
        },
        enabled: !!serviceUid,
    });
};

export const useCreateReadingTemplate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ serviceUid, data }) => api.createReadingTemplate(serviceUid, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['reading-templates'] });
        },
    });
};

export const useUpdateReadingTemplate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ uid, data }) => api.updateReadingTemplate(uid, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['reading-templates'] });
        },
    });
};

export const useDeleteReadingTemplate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ uid }) => api.deleteReadingTemplate(uid),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['reading-templates'] });
        },
    });
};
